<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='existeDadosGeoEspaciais(restricoes[index])'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nomeProdutor') }}:
                |
                | {{ restricao.nome_produtor || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.cpfCnpj') }}:
                |
                | {{ restricao.documento ? formatarCpfCnpj(restricao.documento) : '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.data') }}:
                |
                | {{ restricao.data_denuncia || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.uf') }}:
                |
                | {{ restricao.uf || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.municipioDenuncia') }}:
                |
                | {{ restricao.municipio || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.status') }}:
                |
                | {{ restricao.status || '-' }}
</template>

<script>
import { mascaraCPF, mascaraCNPJ } from '@/utils/mascaras';

export default {
    name: 'denuncias-produtores-bunge',

    data() {
        return {};
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                const base = value.properties ? { ...value.properties } : { ...value };
                return Object.fromEntries(
                    Object.entries(base).map(([k, v]) => [k, this.formatFieldValue(k, v)])
                );
            });
        }
    },

    methods: {
        formatFieldValue(chave, valor) {
            if (['uf', 'municipio'].includes(chave) && typeof valor === 'string') {
                let texto = valor.trim();
                if (texto.length >= 2 && texto.startsWith('{') && texto.endsWith('}')) {
                    texto = texto.slice(1, -1).trim();
                }
                texto = texto.replace(/['"]+/g, '');

                return texto || '-';
            }
            return valor;
        },
        formatarCpfCnpj(cpfCnpj) {
            if (!cpfCnpj) return '';

            cpfCnpj = cpfCnpj.replace(/[\n\r]/g, '');

            const lista = cpfCnpj.split(',');
            if (lista.length > 1) return lista.map(this.formatarCpfCnpj).join(', ');

            cpfCnpj = cpfCnpj.replace(/\D/g, '');

            if (cpfCnpj.length === 11) return mascaraCPF(cpfCnpj);
            if (cpfCnpj.length === 14) return mascaraCNPJ(cpfCnpj);

            return cpfCnpj;
        },
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes,
                index
            );
        },
        existeDadosGeoEspaciais(restricao) {
            const { geometry, geometria, properties } = restricao;

            if (properties?.latitude && properties?.longitude) {
                return true;
            }

            return (
                this.habilitarZoomRestricao &&
                (geometry || geometria || this.geometria)
            );
        }
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>
